module.exports = __webpack_public_path__ + "static/assets/db95353707870884d21a8015d8fca90d.svg";